import axios, { AxiosResponse } from 'axios'
import { getUserToken } from './utility/localStorageFunctions'

const BASE_URL = `${process.env.REACT_APP_BASE_API_URL}/driverLocations-api/driverLocations`

export type DriverLocationStatus = 'Available' | 'Booked' | 'Unavailable'

export interface DriverLocation {
  latitude: number
  longitude: number
  eta: number
  status: DriverLocationStatus
}

export interface DriverLocationsResponse {
  href: string
  rel: string[]
  value: DriverLocation[]
}

const getDriverLocations = async (
  lat: number,
  lng: number,
): Promise<AxiosResponse<DriverLocationsResponse>> => {
  const token = await getUserToken('driverLocations')

  const response = await axios({
    method: 'get',
    headers: {
      Authorization: `Bearer ${token}`,
    },
    url: `${BASE_URL}?lat=${lat}&lng=${lng}`,
  })

  return response
}

export const driverLocationsAPI = {
  getDriverLocations,
}
